<template>
  <v-container>
    <v-layout row v-if="error">
      <v-flex xs12 sm6 offset-sm3>
        <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-card v-if="userid">
          <v-card-text>
            <v-container>
                    <v-btn @click="logout">
                      Sign out
                    </v-btn>              
            </v-container>
          </v-card-text>
        </v-card>

 
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import firebase from 'firebase'

  export default {
    data () {
      return {
        email: '',
        password: ''
      }
    },
    created(){

    },
    computed: {
      user () {
        return this.$store.getters.user
      },
      member () {
        return this.$store.getters.member
      },      
      userid () {
        if(this.$store.getters.user === null){
          return null
        }else{
          return this.$store.getters.user.id
        }
        
      },      
      error () {
        return this.$store.getters.error
      },
      loading () {
        return this.$store.getters.loading
      }
    },
    watch: {
      user (value) {
        if (value === null || value === undefined) {             
           console.log('watching user: ', value)
          this.$router.push('/')
        }
      }
     
    },
    methods: {
      logout (){
        this.$store.dispatch('logout')
      },
      onDismissed () {
        this.$store.dispatch('logout')
      }
    }
  }
</script>